import { connect } from 'react-redux';
import { pipe } from 'fp-ts/function';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { commanderForm } from '@mews-commander/legacy-form';
import { editResources, deselectAllResources } from '../../../actions/resources';
import ParentResourceSelectField from './ParentResourceSelectField';

interface ResourceBulkEditFormValues {
    parentResourceBuilderId: string;
}

interface DispatchProps {
    onSubmit: (values: ResourceBulkEditFormValues) => void;
}

interface OwnProps {
    resourceIds: string[];
}

export default pipe(
    ParentResourceSelectField,
    commanderForm<ResourceBulkEditFormValues, {}>({
        enableReinitialize: true,
        submitLabel: <LocalizedText textKey={TextKey.Assign} />,
    }),
    connect<{}, DispatchProps, OwnProps, ApplicationState>(
        undefined,
        (dispatch: CommanderThunkDispatch, { resourceIds }) => ({
            onSubmit: ({ parentResourceBuilderId }) => {
                dispatch(editResources({ resourceIds, parentResourceBuilderId }));
                dispatch(deselectAllResources());
            },
        })
    )
);
